import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { EstatusReclutamiento } from 'src/app/utilerias/enums/ticket-estatus-reclutamiento.enum';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { NgFor } from '@angular/common';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';

@Component({
    selector: 'app-reclutamiento-perfil-ticket',
    templateUrl: './reclutamiento-perfil-ticket.component.html',
    styleUrls: ['./reclutamiento-perfil-ticket.component.css'],
    imports: [MatIconButton, MatIcon, MatChipListbox, NgFor, MatChipOption, MatFormField, MatLabel, MatInput, MatSuffix, MatButton]
})
export class ReclutamientoPerfilTicketComponent {
  ESTATUS_RECLUTAMIENTO = Object.values(EstatusReclutamiento)
  constructor(public modalReclutamiento: MatDialogRef<ReclutamientoPerfilTicketComponent>,){
    console.log(this.ESTATUS_RECLUTAMIENTO);
  }
  onCloseClick() {
    this.modalReclutamiento.close();
  }
}
